
import { Vue, Component, Mixins, Prop } from 'vue-property-decorator'
import * as VDialog from 'vuetify/es5/components/VDialog'
import XBtn from '@/components/xLib/XBtn'
import { StateAuthorItems } from '@/helpers/state'

@Component({
  components: {
    ...VDialog,
    XBtn,
  },
})
export default class ItemAuthorConfirmDialog extends Mixins(Vue, StateAuthorItems) {
  @Prop({ default: false }) show: boolean

  onContinue() {
    this.$emit('confirm-action', {
      cancel: false,
    })
  }

  onCancel() {
    this.$emit('confirm-action', {
      cancel: true,
    })
  }
}
